import { ComponentRef, ViewContainerRef } from '@angular/core';
import { AccountSelectionComponent } from './account-selection.component';

class AccountSelectionSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  accountSelectionFormSessionCompRef: ComponentRef<AccountSelectionComponent>;

  constructor(formId: string, payload: object) {
      this.formId = formId;
      this.payload = payload;
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }

  endSession(): void {
  }

  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    this.viewContainerRef.clear();

    this.accountSelectionFormSessionCompRef = this.viewContainerRef.createComponent(AccountSelectionComponent);

    this.accountSelectionFormSessionCompRef.instance.onAccountSubmit = this.onSubmitAccountSelection.bind(this);

    this.accountSelectionFormSessionCompRef.instance.subscriptionInfoModel = this.payload['body']['subscriptionInfo'];

    const journeyPayload = this.payload as JourneyPayload;

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          this.submitBlock = null; // prevent reuse of a settled promise
        } catch (e) {
          console.error(e);
        }
      };
    });
  }

  onContinue(payload: object): void {
  }

  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private onSubmitAccountSelection(payload: object) {
    const data = payload;
    this.submitBlock(data);
  }
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default AccountSelectionSession;
